var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscapegarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    stroke: "#FFAB2B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7841 21.2472C13.5219 23.8449 20.1608 26.3252 20.1608 26.3252V31.7018H22.5504V26.9226H25.8361L24.6413 11.0914C24.6413 11.0914 22.9525 9.72214 21.6543 9.59788C18.9434 9.33843 17.4845 11.8098 16.5763 14.3771C15.915 16.2466 17.5792 17.7443 16.5763 19.455C16.0758 20.3089 15.2167 20.357 14.7841 21.2472Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1157 27.5769L21.9535 21.5455H19.8626L23.447 15.5714H21.6548L25.7505 9L29.7197 15.5714H28.5249L31.5005 21.5455H29.7197L32.3851 27.5195H27.3301V31.7013H24.6418V27.5195L19.1157 27.5769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9535 21.5455L19.1157 27.5769L24.6418 27.5195M21.9535 21.5455H19.8626L23.447 15.5714M21.9535 21.5455H29.7197M23.447 15.5714H21.6548L25.7505 9L29.7197 15.5714H28.5249M23.447 15.5714H28.5249M28.5249 15.5714L31.5005 21.5455H29.7197M29.7197 21.5455L32.3851 27.5195H27.3301M24.6418 27.5195V31.7013H27.3301V27.5195M24.6418 27.5195H27.3301",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2781 32.0001V29.7598M7.61572 27.5195H9.10923M9.10923 27.5195H17.7716H16.2781V29.7598M9.10923 27.5195V29.7598M9.10923 32.0001V29.7598M9.10923 29.7598H16.2781",
    stroke: "black",
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10899 25.4288V14.0781H8.21289H10.3038",
    stroke: "black",
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95028 12.6819L9.40793 12.1534L9.86558 12.6819H8.95028Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapegarden);
export default __webpack_public_path__ + "static/media/landscape garden.5cf120114c1d333368889999618c065d.svg";
export { ForwardRef as ReactComponent };